import GenericTracker from "./generic-tracker";
import { GtmEvent } from "./global-event";

export default class GtmTracker extends GenericTracker {
    constructor () {
        super();
    }

    track(event: GtmEvent) {
        window.dataLayer.push(event);
    }
}